import { useQuery } from "@tanstack/react-query"
import { makeGetSynthesisSession } from "../../domain/use-cases/get-synthesis-session"
import { httpSynthesisSessionRepository } from "../../data/repositories/synthesis-session-repository"

const getSession = makeGetSynthesisSession(httpSynthesisSessionRepository)

export const useSynthesisSession = (sessionId: string | undefined) =>
  useQuery({
    queryKey: ["synthesis-sessions", sessionId],
    queryFn: () => getSession(sessionId!),
    enabled: Boolean(sessionId),
    staleTime: Infinity,
  })
